import { api } from '@/fsd/shared/api';

export type WarehouseKind =
  | 'WB_FBO'
  | 'WB_FBS'
  | 'OZON_FBO'
  | 'OZON_FBS'
  | 'LOCAL'
  | 'DEFECT';

export interface WarehouseOption {
  id: number;
  name: string;
}

interface WarehouseFilters {
  kinds?: WarehouseKind[];
  name?: string;
}

interface GetWarehousesV2Params {
  page: number;
  limit: number;
  filters?: WarehouseFilters;
}

interface WarehousesResponse {
  data: WarehouseOption[];
  meta: {
    total: number;
  };
}

export const getWarehousesV2 = ({
  page,
  limit,
  filters = {},
}: GetWarehousesV2Params): Promise<WarehousesResponse> => {
  return api.post<WarehousesResponse>('/api/v2/general/warehouse/', {
    body: {
      page,
      limit,
      filters,
    },
  });
};